import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useRecontactTemplate } from './recontact-template-context';
import { RejectionReason } from './rejection-reason.component';

export const RecontactTemplateCard = () => {
  const { t } = useTranslation();
  const { state, openModal } = useRecontactTemplate();
  const template = state?.template;

  if (
    !state ||
    (template && !['pending', 'rejected'].includes(template.status))
  ) {
    return null;
  }

  if (!template) {
    return (
      <Box px={6} pt={5}>
        <Button
          variant="outline"
          onClick={openModal}
          data-testid="recontact-template-use-suggested"
        >
          {t('manager.sections.templates.recontact_template.use_suggested')}
        </Button>
      </Box>
    );
  }

  const rejected = template.status === 'rejected';

  return (
    <Box px={6} pt={5}>
      <Alert
        status={rejected ? 'warning' : 'info'}
        borderRadius="md"
        data-testid="recontact-template-status"
      >
        <AlertIcon />
        <AlertDescription flex={1}>
          {t(
            rejected
              ? 'manager.sections.templates.recontact_template.rejected'
              : 'manager.sections.templates.recontact_template.pending'
          )}
          {rejected && template.reason && (
            <>
              {' '}
              {t(
                'manager.sections.templates.recontact_template.rejected_reason'
              )}{' '}
              <RejectionReason reason={template.reason} />
            </>
          )}
        </AlertDescription>
        {rejected && (
          <Button size="sm" variant="primary" onClick={openModal}>
            {t(
              'manager.sections.templates.recontact_template.edit_and_resubmit'
            )}
          </Button>
        )}
      </Alert>
    </Box>
  );
};
